import RestAPI from "../../../util/RestAPI";

export async function startFreeTrial(type: "7-day" | "30-day") {
  await RestAPI.post(`/users/free-trials/${type}`);
}
